import { setChangeTypesAction } from "./setChangeType.action";
import { MAP_CONFIG_LOADED } from "../../../../MapStore2/web/client/actions/config";
import { defaultChangeTypesSelector } from "../../../common/selector/configurationSelector";
import { EpicFactory } from "../../../core/core-redux/reduxTypes";
import { Action } from "redux";
import { RootState } from "../../../rootState";

export const changeTypeEpic: EpicFactory<Action, RootState, Action> = (action, store) =>
    action.ofType(MAP_CONFIG_LOADED).map(() => {
        const state = store.getState();

        return setChangeTypesAction(defaultChangeTypesSelector(state));
    });
